import { useEffect, useMemo, useState } from "react";
import FolderList from "./FolderList";
import { Box, Stack } from "@mui/material";

const FolderSelectorList = ({
    isActive = true,
    selectionMode = 'single',
    selectedFolderId = null,
    selectedFolderIds = null,
    onSelect = () => { },
}) => {
    const [currentSelectedFolderId, setCurrentSelectedFolderId] = useState(selectedFolderId);
    const [currentSelectedFolderIds, setCurrentSelectedFolderIds] = useState(Array.isArray(selectedFolderIds) ? selectedFolderIds : []);

    useEffect(() => {
        setCurrentSelectedFolderId(selectedFolderId);
    }, [selectedFolderId]);

    useEffect(() => {
        if (Array.isArray(selectedFolderIds)) {
            setCurrentSelectedFolderIds(selectedFolderIds);
        }
    }, [selectedFolderIds]);

    const normalizedSelectedFolderIds = useMemo(
        () => Array.isArray(currentSelectedFolderIds) ? currentSelectedFolderIds : [],
        [currentSelectedFolderIds]
    );

    const onItemClickHandler = (item) => {
        if (selectionMode === 'multiple') {
            const nextSelectedFolderIds = normalizedSelectedFolderIds.includes(item.id)
                ? normalizedSelectedFolderIds.filter((id) => id !== item.id)
                : [...normalizedSelectedFolderIds, item.id];

            setCurrentSelectedFolderIds(nextSelectedFolderIds);
            onSelect(item, nextSelectedFolderIds);
            return;
        }

        const nextSelectedFolderId = currentSelectedFolderId === item.id ? null : item.id;

        setCurrentSelectedFolderId(nextSelectedFolderId);
        onSelect(item, nextSelectedFolderId);
    };

    return (
        <>
            <Stack alignItems="center" mt={2} width="100%">
                <Box border="1px solid #ccc" borderRadius={1} p={1} width="100%">
                    <FolderList
                        isActive={isActive}
                        selectionMode={selectionMode}
                        selectedFolderId={selectionMode === 'single' ? currentSelectedFolderId : null}
                        selectedFolderIds={selectionMode === 'multiple' ? normalizedSelectedFolderIds : []}
                        onSelect={onItemClickHandler}
                    />
                </Box>
            </Stack >
        </>
    );
};

export default FolderSelectorList;
